import { matchPath } from 'react-router-dom/cjs/react-router-dom';
import { isArray, isStringEmpty } from '../../../utils/isDefined';
import { mapSearchValue } from '../../../utils/tableUtils';

export default function mapCustomFilters({ filter, obj, value }) {
  if (isArray(value) && value.length >= 2) {
    return obj;
  }

  const mappedValue = isArray(value) ? value.join(',') : mapSearchValue(value);

  if (isStringEmpty(mappedValue)) {
    return { ...obj };
  }

  const eqSearchFields = [
    'range_from',
    'range_up_to_incl',
    'status',
    'id',
    'interval',
    'platform'
  ];

  if (eqSearchFields.includes(filter.column.field)) {
    return { ...obj, [filter.column.field]: { eq: mappedValue } };
  }

  switch (filter.column.field) {
    case 'och_active_at': {
      if (!/^\d{2}-\d{2}-\d{4}$/.test(mappedValue)) return { ...obj };
      const [ochActiveDay, ochActiveMonth, ochActiveYear] = mappedValue.split(
        '-'
      );
      const ochActiveIso = `${ochActiveYear}-${ochActiveMonth}-${ochActiveDay}`;
      const ochActiveDate = new Date(ochActiveIso);
      ochActiveDate.setDate(ochActiveDate.getDate() - 1);
      const ochActivePrevDay = ochActiveDate.toISOString().slice(0, 10);
      return {
        ...obj,
        [`och_active_at`]: {
          gte: `${ochActivePrevDay}T22:00:00Z`,
          lt: `${ochActiveIso}T22:00:00Z`
        }
      };
    }
    case 'och_inactive_at': {
      if (!/^\d{2}-\d{2}-\d{4}$/.test(mappedValue)) return { ...obj };
      const [
        ochInactiveDay,
        ochInactiveMonth,
        ochInactiveYear
      ] = mappedValue.split('-');
      const ochInactiveIso = `${ochInactiveYear}-${ochInactiveMonth}-${ochInactiveDay}`;
      const ochInactiveDate = new Date(ochInactiveIso);
      ochInactiveDate.setDate(ochInactiveDate.getDate() - 1);
      const ochInactivePrevDay = ochInactiveDate.toISOString().slice(0, 10);
      return {
        ...obj,
        [`och_inactive_at`]: {
          gte: `${ochInactivePrevDay}T22:00:00Z`,
          lt: `${ochInactiveIso}T22:00:00Z`
        }
      };
    }
    case 'providerName':
      return { ...obj, [`provider_sane_name`]: { eq: mappedValue } };
    case 'clientName':
      return { ...obj, [`client_name`]: { match: mappedValue } };
    default:
      return { ...obj, [filter.column.field]: { match: mappedValue } };
  }
}
